import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import signatureDataFragment from '../signatureDataFragment'
import BrowseVersion from '../BrowseVersion'
import ASignature from './ASignature'

@withMutation(gql`
  mutation setDefaultSignature($signatureId: ID!) {
    setDefaultSignature(signatureId: $signatureId) {
      ...signatureData
    }
  }
  ${signatureDataFragment}
`)
@withMutation(gql`
  mutation deleteSignature($signatureId: ID!) {
    deleteSignature(signatureId: $signatureId) {
      ...signatureData
    }
  }
  ${signatureDataFragment}
`)
@withGraphQL(gql`
  query getMySignatures {
    me {
      ...signatureData
    }
  }
  ${signatureDataFragment}
`)
@withMessage
export default class MySignaturesMini extends React.Component {
  static propTypes = {
    me: PropTypes.func,
    ifEmpty: PropTypes.func,
    isReady: PropTypes.func,
    isDefault: PropTypes.bool,
    showMessage: PropTypes.func,
    deleteSignature: PropTypes.func,
    setDefaultSignature: PropTypes.func
  }
  state = {
    textLoading: 'n'
  }

  @autobind
  async setDefault(signatureId) {
    global.selSignatureId = signatureId
    await this.setState({textLoading: 'y'})
    try {
      // if (this.props.isDefault) {
      await this.props.setDefaultSignature({signatureId})
      // }
      this.props.isReady(signatureId)
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    await this.setState({textLoading: 'n'})
  }

  @autobind
  async deleteSignature(signatureId) {
    this.setState({textLoading: 'y'})
    try {
      await this.props.deleteSignature({signatureId})
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({textLoading: 'n'})
  }

  renderNoSignatures() {
    this.props.ifEmpty()
    return <div>Sin firma</div>
  }

  renderSignatures() {
    if (this.props.me.signatures.length === 0) return this.renderNoSignatures()
    return this.props.me.signatures.map(signature =>
      (
        <div key={signature._id} className={`${styles.signatureContainer} ${signature.default ? styles.defaultSignature : styles.signature}`}>
          <ASignature
            signature={signature}
            setDefault={this.setDefault}
            textLoading={this.state.textLoading}
            deleteSignature={this.deleteSignature}
          />
        </div>
      )
    )
  }

  render() {
    return (
      <div className={`${styles.container} ${this.state.textLoading === 'y' ? 'isLoading' : ''}`}>
        <div className="shadowCover" />
        <div className={styles.signaturesContainer}>
          {this.renderSignatures()}
        </div>
        <BrowseVersion />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Signature/MySignaturesMini/index.js